import React from 'react';
import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';

import { Icon, IconTypes } from '@eika/icon';

import { openStep, sblFailed } from '../../../actions';
import { StringKeyValue } from '../../../actions/types';
import { AppState } from '../../../reducers';
import { LoaderReducer } from '../../../reducers/loader';
import { SblReducer } from '../../../reducers/sbl';
import { TrackingStep, trackEvent } from '../../../util/piwik-utils';
import Loading from '../../Messages/Loading';
import StepButtons from '../../Steps/StepButtons';

interface Props {
    action: {
        openStep: (destinationStep: number) => void;
        sblFailed: () => void;
    };
    loader: LoaderReducer;
    sbl: SblReducer;
    text: StringKeyValue;
}

const Sbl = (props: Props) => {
    const { loader, text, action, sbl } = props;
    const { customerUrl, sblStatus } = sbl;
    const { isCreatingSblConsent } = loader;

    const goToAltinnClick = () => {
        if (customerUrl && sblStatus && ['UNOPENED', 'OPENED'].includes(sblStatus)) {
            window.location.href = customerUrl;
        } else if (sblStatus === 'ACCEPTED') action.openStep(2);
        else {
            action.sblFailed();
        }
    };

    if (isCreatingSblConsent) return <Loading title={text.loadingDefault} />;

    return (
        <div>
            <h2>{text.sblTitle}</h2>
            <p>{text.sblInfoText1}</p>
            <p>{text.sblInfoText2}</p>
            <StepButtons
                showNext
                nextChangeEvent={() => {
                    trackEvent(TrackingStep.Sbl);
                    goToAltinnClick();
                }}
                nextButtonName={
                    <>
                        {text.sblGoToAltinnButtonText} <Icon type={IconTypes.EKSTERN_24} />
                    </>
                }
            />
        </div>
    );
};

const mapStateToProps = (state: AppState) => ({
    loader: state.loader,
    text: state.context.config.data.text,
    sbl: state.sbl,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    action: bindActionCreators(
        {
            openStep,
            sblFailed,
        },
        dispatch,
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Sbl);
